import React, {useEffect} from 'react';

import styled from 'styled-components';
import { Contents } from 'view/components';
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {Alert, isAdmin, selectedMenu, subMenuState} from "../../../../state";
import CloseBtn from "../../../components/common/CloseBtn";
import {useNavigate} from "react-router-dom";

interface PopupProps{
    onChange:any,
    value:string,
    onClick:any
}

const CreatePopup: React.FC<PopupProps> = ({onChange, value, onClick}) => {

    const [selected, setSelected] = useRecoilState(selectedMenu);
    const [selectedSubMenu ,setSelectedSubMenu] = useRecoilState(subMenuState);

    const isAdminState = useRecoilValue(isAdmin);
    const navigate = useNavigate()

    const setAlert = useSetRecoilState(Alert)
    const onKeyDown = (e) => {
        console.log("@e",e);
        if(e.keyCode == 13){
            // onClick()
            if(value.length < 10){
                if(value.length == 0) {
                    setAlert({
                        isActive:true,
                        text:"Please enter a title to proceed.",
                        desc:"Enter a title",
                        type:"info",
                        color:"blue",
                        time: 1300
                    })
                }else {
                    setAlert({
                        isActive:true,
                        text:"The number of characters in the title must be between 10 and 70",
                        desc:"",
                        type:"warn",
                        color:"yellow",
                        time: 1300
                    })
                }

            }else{
                onClick()
            }
        }

    }
    useEffect(() => {
        document.addEventListener("keydown",(e)=>{
            if(e.keyCode == 27){
                if(!isAdminState){
                    setSelected("Classes");
                    navigate("/main/classes")
                }else{
                    setSelected("Classes");
                    navigate("/main/classes")
                    setSelectedSubMenu("In Progress")
                }
            }
        })
    }, []);
    return (
        <Container>
            <Contents title={"Class Title"} className={"popup"}>
                <CloseBtn style={{ position:"absolute", right:0, top:0}}
                    onClick={()=>{
                        if(!isAdminState){
                            setSelected("Classes");
                            navigate("/main/classes")
                        }else{
                            setSelected("Classes");
                            navigate("/main/classes")
                            setSelectedSubMenu("In Progress")
                        }
                    }}
                />
                <Inner>
                    <h1>How about a working title?</h1>
                    <p>It’s ok if you can’t think of a good title now. You can change it later.</p>
                    <FormBoxItemWrap>
                        <li>
                            <FormItem>
                                <input
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {onChange(e.target.value)}}
                                    type="text"
                                    value={value}
                                    placeholder="Enter a title"
                                    maxLength={70}
                                    onKeyDown={(e)=>{(onKeyDown(e))}}

                                />
                                <TextLength>
                                    {70 - value.length}
                                </TextLength>
                            </FormItem>
                        </li>
                    </FormBoxItemWrap>
                    <Continue
                        style={{
                            opacity:value.length < 10 ? 0.5 : 1,
                            pointerEvents:value.length < 10 ? "none" : "all"
                        }}
                    onClick={()=>{
                        if(value.length < 10){
                            if(value.length == 0) {
                                setAlert({
                                    isActive:true,
                                    text:"Please enter a title to proceed.",
                                    desc:"Enter a title",
                                    type:"info",
                                    color:"blue",
                                    time: 1300
                                })
                            }else {
                                setAlert({
                                    isActive:true,
                                    text:"The number of characters in the title must be between 10 and 70",
                                    desc:"",
                                    type:"warn",
                                    color:"yellow",
                                    time: 1300
                                })
                            }

                        }else{
                            onClick()
                        }
                    }}>
                        <span>Continue</span>
                    </Continue>
                </Inner>
            </Contents>
        </Container>
    );
};
export default CreatePopup;

const Container = styled.div`
    h1 {
        font-size: 28px;
        font-weight: 700;
        color: #333;
        margin-bottom: 30px;
    }
    @media screen and (max-width: 768px) {
        margin: 0 auto;
        width: 90%;
    }
`;
const Inner = styled.div`
    padding: 30px 40px 40px 40px;
    @media screen and (max-width: 768px) {
        width: 100%;
    }
    width: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;
    p {
        font-size: 18px;
        font-weight: 400;
        margin-bottom: 40px;
    }
`;
const FormBoxItemWrap = styled.ul`
    width: 100%;
    margin-bottom: 40px;
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
`;

const FormItem = styled.div`
    position: relative;
    > input[type="text"],
    select,
    textarea {
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 16px;
        &::placeholder {
            color: #ddd;
        }
    }
    > input[type="text"] {
        height: 48px;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 17px;
`;

const Continue = styled.div`
    padding: 11px 30.5px;
    border-radius: 6px;
    border: solid 1px #333;
    cursor: pointer;
    transition: all 0.2s;
    &:hover{
        background: #333;
        color: #fff;
        span{
            color: #fff;
        }
    }
    span{
        transition: all 0.2s;
        font-size: 18px;
        font-weight: 400;
        color: #333;
     
    }
`; 